var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.917 11.666h-.658l-.234-.225a5.416 5.416 0 0 0 1.234-4.45c-.392-2.317-2.325-4.167-4.659-4.45a5.42 5.42 0 0 0-6.058 6.058c.283 2.334 2.133 4.267 4.45 4.659a5.418 5.418 0 0 0 4.45-1.234l.225.234v.658l3.542 3.542a.88.88 0 0 0 1.241 0 .88.88 0 0 0 0-1.242l-3.533-3.55Zm-5 0a3.745 3.745 0 0 1-3.75-3.75 3.745 3.745 0 0 1 3.75-3.75 3.745 3.745 0 0 1 3.75 3.75 3.745 3.745 0 0 1-3.75 3.75Z",
    fill: "#fff"
  })));
};
export default SvgSearch;